import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect, useCallback } from 'react';
import { single, highlight } from 'fuzzysort';

function useSelectableList(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    _setSelected = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    search = _useState4[0],
    setSearch = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    highlightedStrings = _useState6[0],
    setHighlightedStrings = _useState6[1];
  var onChange = props.onChange,
    optionList = props.optionList,
    noFuzzySearch = props.noFuzzySearch;
  useEffect(function () {
    if (search) {
      var val = noFuzzySearch ? search.toLocaleLowerCase() : undefined;
      var regex = noFuzzySearch && !!val ? new RegExp(val, 'ig') : undefined;
      setHighlightedStrings(optionList.reduce(function (acc, cur) {
        if (cur.items && cur.items.length > 0) {
          var filteredItems = cur.items.reduce(function (acc2, e) {
            if (regex) {
              var _e$name, _e$name$toLocaleLower;
              if (!!val && ((_e$name = e.name) === null || _e$name === void 0 ? void 0 : (_e$name$toLocaleLower = _e$name.toLocaleLowerCase()) === null || _e$name$toLocaleLower === void 0 ? void 0 : _e$name$toLocaleLower.indexOf(val)) >= 0) {
                return _objectSpread2(_objectSpread2({}, acc2), {}, _defineProperty({}, e.key, e.name.replaceAll(regex, function (match) {
                  return "<b>".concat(match, "</b>");
                })));
              } else return acc2;
            } else {
              var fuzzy = single(search, e.name);
              if (fuzzy) {
                var _fuzzysort$highlight;
                return _objectSpread2(_objectSpread2({}, acc2), {}, _defineProperty({}, e.key, (_fuzzysort$highlight = highlight(fuzzy)) !== null && _fuzzysort$highlight !== void 0 ? _fuzzysort$highlight : e.name));
              } else return acc2;
            }
          }, {});
          return _objectSpread2(_objectSpread2({}, acc), filteredItems);
        } else return acc;
      }, {}));
    } else {
      setHighlightedStrings({});
    }
  }, [search, optionList, noFuzzySearch, setHighlightedStrings]);
  useEffect(function () {
    if (selected && !props.selectedKey) {
      _setSelected(undefined);
    } else {
      var found = props.optionList.reduce(function (acc, cur) {
        if (cur.items) {
          var foundOption = cur.items.find(function (e) {
            return e.key === props.selectedKey;
          });
          if (foundOption) return foundOption;else return acc;
        } else {
          if (cur.key === props.selectedKey) return cur;else return acc;
        }
      }, null);
      if (found) _setSelected(found);
    }
  }, [props.optionList, props.selectedKey, selected]);
  var _onChange = useCallback(function (arg0) {
    _setSelected(arg0);
    onChange === null || onChange === void 0 ? void 0 : onChange(arg0);
  }, [onChange]);
  return {
    getCategorySelectProps: useCallback(function () {
      return {
        optionList: props.optionList,
        selected: selected,
        onChange: _onChange,
        search: search,
        setSearch: setSearch,
        highlightedStrings: highlightedStrings,
        setHighlightedStrings: setHighlightedStrings
      };
    }, [props.optionList, selected, _onChange, search, highlightedStrings])
  };
}

export { useSelectableList };
//# sourceMappingURL=use-selectable-list.esm.js.map
